/** Shared Google auth helpers for web (parity with KMP OW-182). */

export type PendingGoogleAccount = {
  email: string;
  displayName: string;
  photoURL: string;
  idToken?: string;
};

const PENDING_KEY = 'morafaa_pending_google_account';
const NEW_SIGNUP_KEY = 'morafaa_new_signup_flow';

export function splitDisplayNameToThree(displayName: string): {
  firstName: string;
  middleName: string;
  lastName: string;
} {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { firstName: '', middleName: '', lastName: '' };
  if (parts.length === 1) return { firstName: parts[0], middleName: '', lastName: '' };
  if (parts.length === 2) return { firstName: parts[0], middleName: '', lastName: parts[1] };
  return {
    firstName: parts[0],
    middleName: parts.slice(1, -1).join(' '),
    lastName: parts[parts.length - 1],
  };
}

export function isDemographicsComplete(user: {
  phoneNumber?: string | null;
  birthdate?: string | null;
}): boolean {
  return Boolean(user.phoneNumber?.trim()) && Boolean(user.birthdate?.trim());
}

export function setPendingGoogleAccount(account: PendingGoogleAccount): void {
  sessionStorage.setItem(PENDING_KEY, JSON.stringify(account));
}

export function getPendingGoogleAccount(): PendingGoogleAccount | null {
  const raw = sessionStorage.getItem(PENDING_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PendingGoogleAccount;
  } catch {
    return null;
  }
}

export function clearPendingGoogleAccount(): void {
  sessionStorage.removeItem(PENDING_KEY);
}

export function markNewSignupFlow(active: boolean): void {
  if (active) sessionStorage.setItem(NEW_SIGNUP_KEY, '1');
  else sessionStorage.removeItem(NEW_SIGNUP_KEY);
}

export function isNewSignupFlow(): boolean {
  return sessionStorage.getItem(NEW_SIGNUP_KEY) === '1';
}
